import React from "react";

const Respirstory = () => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    id="vector">
    <path
        id="path"
        d="M 475.3 346.94 C 461.73 262.37 421.38 189.48 365.46 141.9 C 342.19 122.1 306.35 138.9 306.35 169.45 L 306.35 355.9 C 306.35 370.235 312.051 383.997 322.187 394.133 C 332.323 404.269 346.085 409.97 360.42 409.97 L 421.92 409.97 C 455.35 409.97 480.59 379.95 475.3 346.94 Z"
        fill="#a70000"/>
    <path
        id="path_1"
        d="M 146.54 141.9 C 90.62 189.48 50.27 262.37 36.7 346.94 C 31.41 379.95 56.65 409.97 90.08 409.97 L 151.59 409.97 C 165.925 409.97 179.687 404.269 189.823 394.133 C 199.959 383.997 205.66 370.235 205.66 355.9 L 205.66 169.45 C 205.65 138.89 169.81 122.1 146.54 141.9 Z"
        fill="#a70000"/>
    <path
        id="path_2"
        d="M 272.42 102.03 L 239.58 102.03 L 239.58 179.34 C 239.583 183.791 238.707 188.198 237.003 192.31 C 235.299 196.421 232.8 200.156 229.65 203.3 L 229.65 241.53 C 239.8 237.6 248.844 231.261 256 223.06 C 263.156 231.261 272.2 237.6 282.35 241.53 L 282.35 203.3 C 279.2 200.156 276.702 196.421 274.998 192.309 C 273.294 188.198 272.418 183.79 272.42 179.34 Z"
        fill="#a70000"/>
</svg>
  );
};

export default Respirstory;
